import React from 'react'
import PropTypes from 'prop-types'

import Title from 'components/_new/typography/deprecated/Title/Title'
import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import CardHelpItem from './CardHelpItem/CardHelpItem'

import messages from './messages'
import s from './CvcHelpContent.scss'

import cardFrontImage from './images/card-front@2x.png'
import cardBackImage from './images/card-back@2x.png'
import americanExpressPaymentImage from './images/american-express.png'
import visaMasterCardPaymentImage from './images/visa-mastercard@2x.png'


const cardHelpItems = [
  {
    paymentName: 'VISA, MasterCard',
    paymentImage: visaMasterCardPaymentImage,
    cardImage: cardBackImage,
    title: messages.backOfCard,
  },
  {
    paymentName: 'AmericanExpress',
    paymentImage: americanExpressPaymentImage,
    cardImage: cardFrontImage,
    title: messages.frontOfCard,
  },
]

const CvcHelpContent = ({ className }) => (
  <div className={className}>
    <Title message={messages.title} size="lg" html />
    <Text message={messages.text} muted html />
    <Box mt="36">
      <div className={s.cards}>
        {
          cardHelpItems.map((data, index) => (
            <CardHelpItem key={index} className={s.card} {...data} />
          ))
        }
      </div>
    </Box>
  </div>
)

CvcHelpContent.propTypes = {
  className: PropTypes.string,
}


export default CvcHelpContent
